module.exports = __webpack_public_path__ + "img/87.25e25ca3.jpg";